import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

const AgeGateModal = ({ onConfirm, onDeny }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleConfirm = () => {
    setIsVisible(false);
    onConfirm();
  };

  const handleDeny = () => {
    setIsVisible(false);
    onDeny();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 transform transition-all duration-300 scale-100">
        {/* Header */}
        <div className="bg-gradient-to-r from-red-500 to-red-600 text-white p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <AlertTriangle size={32} className="text-white" />
              <h2 className="text-2xl font-bold">Age Verification Required</h2>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl font-bold text-red-600">21+</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              You must be 21 or older to access this website
            </h3>
            <p className="text-gray-600 leading-relaxed">
              This website contains information about cannabis products and is intended for adults only. 
              By clicking "I am 21 or older" below, you confirm that you are of legal age to view this content.
            </p>
          </div>

          {/* Legal Notice */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-600 text-center">
              <strong>Legal Notice:</strong> Cannabis products are for adults 21+ only. 
              Please consume responsibly and in accordance with local laws.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col space-y-3">
            <button
              onClick={handleConfirm}
              className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-4 px-6 rounded-xl font-bold text-lg hover:shadow-lg transition-all duration-300 transform hover:scale-105"
            >
              I am 21 or older
            </button>
            <button
              onClick={handleDeny}
              className="w-full border-2 border-gray-300 text-gray-700 py-4 px-6 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all duration-300"
            >
              I am under 21
            </button>
          </div>

          {/* Footer */}
          <div className="mt-6 pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500 text-center">
              By using this website, you agree to our Terms of Service and Privacy Policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgeGateModal;
